const SWIGGY_MONEY_OFFERS_PREFIX = "sm_offers";

export const SWIGGY_MONEY_OFFERS_TEST_IDS = {
    CONTAINER: `${SWIGGY_MONEY_OFFERS_PREFIX}_container`,
    CONTENT_ITEM: `${SWIGGY_MONEY_OFFERS_PREFIX}_content_item`,
    ICON: `${SWIGGY_MONEY_OFFERS_PREFIX}_icon`,
    TITLE: `${SWIGGY_MONEY_OFFERS_PREFIX}_title`,
};
